module.exports = __webpack_public_path__ + "static/img/ZRS4281_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS4281_1.png
// module id = ep5B
// module chunks = 0